import React from "react";
import PropTypes from "prop-types";
import { Icon, Chip } from "@qgiv/core-react";

const TeamRoleCardContent = ({
    displayOnlyIndividualRegistrationAvailable = false,
    displayTeamLimit = false,
    displayTeamLimitReached = false,
    formattedOnlyIndividualRegistrationAvailableLabel = "",
    formattedTeamLimitLabel = "",
    formattedTeamLimitReachedLabel = "",
}) => (
    // eslint-disable-next-line tailwindcss/classnames-order
    <div className="grid grid--no-gutters">
        {displayTeamLimit && (
            <div className="col col--12">
                <Chip classNames="-margin-top--10" bgColor="system-warning">
                    <Icon
                        className="-margin-right--10"
                        glyph="users-solid"
                        type="FontAwesome"
                    />
                    <small>{formattedTeamLimitLabel}</small>
                </Chip>
            </div>
        )}
        {displayTeamLimitReached && (
            <div className="col col--12">
                <Chip classNames="-margin-top--10" bgColor="system-light">
                    <Icon
                        className="-margin-right--10"
                        glyph="exclamation-circle-solid"
                        type="FontAwesome"
                    />
                    <small>{formattedTeamLimitReachedLabel}</small>
                </Chip>
            </div>
        )}
        {displayOnlyIndividualRegistrationAvailable && (
            <div className="col col--12">
                <Chip classNames="-margin-top--10" bgColor="system-light">
                    <Icon
                        className="-margin-right--10"
                        glyph="exclamation-circle-solid"
                        type="FontAwesome"
                    />
                    <small>
                        {formattedOnlyIndividualRegistrationAvailableLabel}
                    </small>
                </Chip>
            </div>
        )}
    </div>
);

TeamRoleCardContent.propTypes = {
    displayOnlyIndividualRegistrationAvailable: PropTypes.bool,
    displayTeamLimit: PropTypes.bool,
    displayTeamLimitReached: PropTypes.bool,
    formattedOnlyIndividualRegistrationAvailableLabel: PropTypes.string,
    formattedTeamLimitLabel: PropTypes.string,
    formattedTeamLimitReachedLabel: PropTypes.string,
};

export default TeamRoleCardContent;
